import script from "./AppNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavBar.vue?vue&type=script&setup=true&lang=js"

import "./AppNavBar.vue?vue&type=style&index=0&id=b22ffc0c&lang=scss&scoped=true"

import exportComponent from "/builds/partout-chez-nous/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b22ffc0c"]])

export default __exports__